import SupportersApp from "../../../../src/events/2022/05/supporters-app/index.js";
import * as React from 'react';
export default {
  SupportersApp,
  React
};